
    import router from '@/router'
    import { ref, onMounted } from "vue"

// ✅ MOVE THIS FUNCTION OUTSIDE setup() - at the top level
function getTenantHeader() {
    const tenantId = window.location.hostname.split('.')[0].toUpperCase();
    return { 'X-Tenant-ID': tenantId };
}

    export default({
        name: "profileView",
        props: ['baseUrl'],
        setup(props: any) {
            // Loading state
            const isSaving = ref(false)
            const isDataLoaded = ref(false)
            
            // Lists
            const cityList = ref<any[]>([])
            const genderList = ref<any[]>([])
            const documentTypesList = ref<any[]>([])
            const nationalityList = ref<any[]>([])
            const conveyanceListArray = ref([
                { id: 1, name: "Car" }, 
                { id: 2, name: "Motor Bike" }, 
                { id: 3, name: "Public Tpt" }, 
                { id: 4, name: "Bike" }
            ])
            
            // Selected values
            const selectedConveyanceName = ref("")
            const selectedCityName = ref("")
            const selectedGenderType = ref("")
            const selectedNationality = ref("")
            const selectedCountryOfBirth = ref("")
            const selectedAddressCountry = ref("")
            const selectedIdDocumentCountryOfIssue = ref("")
            const selectedIdDocumentName = ref("")
            
            // ID Document fields
            const idDocumentNumber = ref("")
            const idDocumentIssueDate = ref("")
            const idDocumentExpiryDate = ref("")
            const idDocumentId = ref<number | null>(null)
            
            // Form data - simple flat structure
            const formData = ref({
                SecurityOfficerId: 0,
                FirstName: '',
                LastName: '',
                PreviouslyKnownAs: '',
                MobileNumber: '',
                Email: '',
                Phone2: '',
                SiabadageNumber: '',
                SiaExpiryDate: '',
                Ninumber: '',
                HouseNameNumber: '',
                StreetAdress: '',
                County: '',
                PostCode: '',
                NextOfKin: '',
                DateOfBirth: '',
                PlaceOfBirth: '',
                PassportNo: '',
                PassportExpiryDate: '',
                VisaExpiryDate: '',
                SecurityCompanyId: '',
                Active: true,
                Town: '',
                PassportId: null,
                IdentityDocumentId: null,
                PayRate: '0',
                CityId: 0,
                ConveyanceId: 0
            })
            
            const isPrivacyPolicyAgreed = ref(false)
            const officerId = localStorage.getItem("OfficerId")

            // Helper: Convert API date (2026-05-10T00:00:00) to YYYY-MM-DD
            const formatDateForInput = (apiDate: string | null): string => {
                if (!apiDate) return ""
                const match = apiDate.match(/^(\d{4}-\d{2}-\d{2})/)
                return match ? match[1] : ""
            }

            // Helper: Format date for display (DD/MM/YYYY)
            const formatDateForDisplay = (dateValue: string) => {
                if (!dateValue) return ""
                const parts = dateValue.split('-')
                if (parts.length === 3) {
                    return `${parts[2]}/${parts[1]}/${parts[0]}`
                }
                return dateValue
            }

            // Load all data in parallel
            const loadData = async () => {
                const token = localStorage.Guardtoken
                
                const headers = {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                     //...getTenantHeader()  // ← Spread the header
                }

                try {
                    // Parallel API calls
                    const [utilityRes, citiesRes, profileRes] = await Promise.all([
                        fetch(props.baseUrl + "SecurityOfficers/GenderAndDocumentTypesAndNationalityList", { headers }),
                        fetch(props.baseUrl + "Cities/Cities", { headers }),
                        fetch(props.baseUrl + "securityofficers/OfficerFullDetailById", {
                            method: "POST",
                            headers,
                            body: JSON.stringify({ "Id": parseInt(officerId || "0") })
                        })
                    ])

                    const utilityData = await utilityRes.json()
                    const citiesData = await citiesRes.json()
                    const profileData = await profileRes.json()

                    // Populate lists
                    genderList.value = utilityData?.utilityService?.gendersList || []
                    documentTypesList.value = utilityData?.utilityService?.documentTypesList || []
                    nationalityList.value = utilityData?.utilityService?.nationalityList || []
                    cityList.value = citiesData?.cities || []

                    // Populate form data
                    const data = profileData.officerFullDetailViewModel
                    if (data) {
                        formData.value = {
                            SecurityOfficerId: data.securityOfficerId || 0,
                            FirstName: data.firstName || '',
                            LastName: data.lastName || '',
                            PreviouslyKnownAs: data.previouslyKnownAs || '',
                            MobileNumber: data.mobileNumber || '',
                            Email: data.email || '',
                            Phone2: data.phone2 || '',
                            SiabadageNumber: data.siabadageNumber || '',
                            SiaExpiryDate: formatDateForInput(data.siaExpiryDate),
                            Ninumber: data.ninumber || '',
                            HouseNameNumber: data.houseNameNumber || '',
                            StreetAdress: data.streetAdress || '',
                            County: data.county || '',
                            PostCode: data.postCode || '',
                            NextOfKin: data.nextOfKin || '',
                            DateOfBirth: formatDateForInput(data.dateOfBirth),
                            PlaceOfBirth: data.placeOfBirth || '',
                            PassportNo: data.passport?.passportNo || '',
                            PassportExpiryDate: formatDateForInput(data.passport?.passportExpiryDate),
                            VisaExpiryDate: formatDateForInput(data.passport?.visaExpiryDate),
                            SecurityCompanyId: data.securityCompanyId || '',
                            Active: true,
                            Town: data.town || '',
                            PassportId: data.passportId || null,
                            IdentityDocumentId: data.identityDocumentId || null,
                            PayRate: data.payRate || '0',
                            CityId: data.cityId || 0,
                            ConveyanceId: data.conveyanceId || 0
                        }

                        // Set selected values from IDs
                        const cityObj = cityList.value.find((c: any) => c.cityId === data.cityId)
                        const genderObj = genderList.value.find((g: any) => g.id === data.genderId)
                        const nationalityObj = nationalityList.value.find((n: any) => n.id === data.nationalityId)
                        const birthCountryObj = nationalityList.value.find((n: any) => n.id === data.countryOfBirthId)
                        const addressCountryObj = nationalityList.value.find((n: any) => n.id === data.addressCountryId)
                        
                        selectedCityName.value = cityObj?.name || ''
                        selectedGenderType.value = genderObj?.name || ''
                        selectedNationality.value = nationalityObj?.name || ''
                        selectedCountryOfBirth.value = birthCountryObj?.name || ''
                        selectedAddressCountry.value = addressCountryObj?.name || ''
                        selectedConveyanceName.value = conveyanceListArray.value.find(c => c.id === data.conveyanceId)?.name || ''
                        
                        // ID Document data
                        if (data.identityDocument) {
                            idDocumentNumber.value = data.identityDocument.number || ''
                            idDocumentIssueDate.value = formatDateForInput(data.identityDocument.issueDate)
                            idDocumentExpiryDate.value = formatDateForInput(data.identityDocument.expiryDate)
                            idDocumentId.value = data.identityDocument.id || null
                            
                            const docCountryObj = nationalityList.value.find((n: any) => n.id === data.identityDocument.countryOfIssueId)
                            selectedIdDocumentCountryOfIssue.value = docCountryObj?.name || ''
                            
                            const docTypeObj = documentTypesList.value.find((d: any) => d.id === data.identityDocument.typeId)
                            selectedIdDocumentName.value = docTypeObj?.name || ''
                        }
                    }
                    
                    isDataLoaded.value = true
                } catch (error) {
                    console.error("Load error:", error)
                }
            }


const UpdateOfficer = async () => {
    if (!isPrivacyPolicyAgreed.value) {
        alert("Please read and agree to the Privacy Policy.")
        return
    }

    // Debug: Log selected values to see what's happening
    console.log("Selected Values:", {
        selectedCityName: selectedCityName.value,
        selectedGenderType: selectedGenderType.value,
        selectedNationality: selectedNationality.value,
        selectedCountryOfBirth: selectedCountryOfBirth.value,
        selectedAddressCountry: selectedAddressCountry.value,
        selectedConveyanceName: selectedConveyanceName.value,
        selectedIdDocumentName: selectedIdDocumentName.value,
        selectedIdDocumentCountryOfIssue: selectedIdDocumentCountryOfIssue.value
    })

    // Get IDs from selected names with better error checking
    const cityObj = cityList.value.find((c: any) => c.name === selectedCityName.value)
    if (!cityObj) { 
        alert(`Please select a valid city. "${selectedCityName.value}" not found.`)
        return 
    }
    const cityId = cityObj.cityId

    const genderObj = genderList.value.find((g: any) => g.name === selectedGenderType.value)
    if (!genderObj) { 
        alert(`Please select a valid gender. "${selectedGenderType.value}" not found.`)
        return 
    }
    const genderId = genderObj.id

    const nationalityObj = nationalityList.value.find((n: any) => n.name === selectedNationality.value)
    if (!nationalityObj) { 
        alert(`Please select a valid nationality. "${selectedNationality.value}" not found in list.`)
        console.log("Available nationalities:", nationalityList.value.map(n => n.name))
        return 
    }
    const nationalityId = nationalityObj.id

    const countryOfBirthObj = nationalityList.value.find((n: any) => n.name === selectedCountryOfBirth.value)
    if (!countryOfBirthObj) { 
        alert(`Please select a valid country of birth. "${selectedCountryOfBirth.value}" not found.`)
        return 
    }
    const countryOfBirthId = countryOfBirthObj.id

    const addressCountryObj = nationalityList.value.find((n: any) => n.name === selectedAddressCountry.value)
    if (!addressCountryObj) { 
        alert(`Please select a valid address country. "${selectedAddressCountry.value}" not found.`)
        return 
    }
    const addressCountryId = addressCountryObj.id

    const conveyanceObj = conveyanceListArray.value.find(c => c.name === selectedConveyanceName.value)
    if (!conveyanceObj) { 
        alert(`Please select a valid conveyance. "${selectedConveyanceName.value}" not found.`)
        return 
    }
    const conveyanceId = conveyanceObj.id

    const documentTypeObj = documentTypesList.value.find((d: any) => d.name === selectedIdDocumentName.value)
    if (!documentTypeObj && selectedIdDocumentName.value) { 
        alert(`Please select a valid document type. "${selectedIdDocumentName.value}" not found.`)
        return 
    }
    const documentTypeId = documentTypeObj?.id || null

    const idDocumentCountryObj = nationalityList.value.find((n: any) => n.name === selectedIdDocumentCountryOfIssue.value)
    if (!idDocumentCountryObj && selectedIdDocumentCountryOfIssue.value) { 
        alert(`Please select a valid document country of issue. "${selectedIdDocumentCountryOfIssue.value}" not found.`)
        return 
    }
    const idDocumentCountryId = idDocumentCountryObj?.id || null

    isSaving.value = true

    const payload = {
        SecurityOfficerId: formData.value.SecurityOfficerId,
        FirstName: formData.value.FirstName,
        LastName: formData.value.LastName,
        PostCode: formData.value.PostCode,
        CityId: cityId,
        County: formData.value.County,
        StreetAdress: formData.value.StreetAdress,
        Town: formData.value.Town || "",
        Active: formData.value.Active,
        SecurityCompanyId: parseInt(formData.value.SecurityCompanyId) || 0,
        SiabadageNumber: formData.value.SiabadageNumber,
        MobileNumber: formData.value.MobileNumber,
        Ninumber: formData.value.Ninumber,
        DesignationId: null,
        DeptId: null,
        PassportId: formData.value.PassportId,
        ConveyanceId: conveyanceId,
        Email: formData.value.Email,
        SiaExpiryDate: formData.value.SiaExpiryDate,
        Phone2: formData.value.Phone2 || "",
        NextOfKin: formData.value.NextOfKin,
        PreviouslyKnownAS: formData.value.PreviouslyKnownAs || "",
        DateOfBirth: formData.value.DateOfBirth,
        PlaceOfBirth: formData.value.PlaceOfBirth,
        HouseNameNumber: formData.value.HouseNameNumber,
        IdentityDocumentId: idDocumentId.value,
        CountryOfBirthId: countryOfBirthId,
        AddressCountryId: addressCountryId,
        NationalityId: nationalityId,
        GenderId: genderId,
        IdentityDocument: {
            Id: idDocumentId.value,
            IssueDate: idDocumentIssueDate.value || null,
            ExpiryDate: idDocumentExpiryDate.value || null,
            CountryOfIssueId: idDocumentCountryId,
            Number: idDocumentNumber.value || "",
            TypeId: documentTypeId
        },
        Passport: {
            PassportNo: formData.value.PassportNo || "",
            PassportExpiryDate: formData.value.PassportExpiryDate || null,
            VisaExpiryDate: formData.value.VisaExpiryDate || null,
            Nationality: ""
        }
    }

    console.log("Sending payload:", payload)

    try {
        const response = await fetch(props.baseUrl + "SecurityOfficers/UpdateSecurityOfficerByOfficerHimself", {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${localStorage.Guardtoken}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })

        const responseText = await response.text()
        console.log("Response:", response.status, responseText)

        if (response.ok) {
            alert("Profile updated successfully!")
            router.push("documents")
        } else {
            alert(`Update failed: ${response.status} ${responseText}`)
        }
    } catch (error) {
        console.error("Update error:", error)
        alert("An error occurred. Please try again.")
    } finally {
        isSaving.value = false
    }
}

            // Load data on mount
            onMounted(() => {
                loadData()
            })

            return {
                formData,
                cityList,
                genderList,
                documentTypesList,
                nationalityList,
                conveyanceListArray,
                selectedConveyanceName,
                selectedCityName,
                selectedGenderType,
                selectedNationality,
                selectedCountryOfBirth,
                selectedAddressCountry,
                selectedIdDocumentCountryOfIssue,
                selectedIdDocumentName,
                idDocumentNumber,
                idDocumentIssueDate,
                idDocumentExpiryDate,
                isPrivacyPolicyAgreed,
                isSaving,
                formatDateForDisplay,
                UpdateOfficer
            }
        },
    })
